import { useQuery } from '@tanstack/react-query'
import { type RegionResponse } from '../types/types'
import { useAuth } from './useAuth'
import { throwOnError } from '../utils/throwOnError'

export const useGetRegionerQuery = (isEnabled = true) => {
  const { authFetch } = useAuth()
  return useQuery({
    staleTime: 1000 * 60 * 60 * 24, // 1 day
    enabled: isEnabled,
    queryKey: ['regioner'],
    queryFn: async () => {
      const { data, error } = await authFetch().GET('/orgenhet-api/regioner')
      if (error) {
        throwOnError(error)
      }
      const response: RegionResponse = data as unknown as RegionResponse
      return response._embedded?.regionList ?? []
    }
  })
}
